<!-- eslint-disable -->
<template>
  <PhonePreview>
    <template v-if="template.body">
      <div v-if="['text', 'TEXT'].includes(template.type)" class="row">
        <RcsBubble :value="template.body.text ? template.body.text : template.body.plain.text" />
      </div>
      <div v-if="['card', 'CARD'].includes(template.type)" class="row">
        <RcsCard :value="template.body.card" is-preview />
      </div>
      <div v-if="['media', 'FILE'].includes(template.type)" class="row">
        <RcsMedia :value="template.body.media.url ? template.body.media.url : template.body.plain.url" is-preview />
      </div>
      <div v-if="['carousel', 'CAROUSELS'].includes(template.type)" class="row carousel">
        <RcsCard v-for="(card, i) in template.body.carousel.cards" :key="i" v-model="template.body.carousel.cards[i]" is-preview />
      </div>
      <div v-if="template.body.suggestions && template.body.suggestions.length > 0">
        <div class="row carousel">
          <RcsSuggestion v-for="(suggestion, n) in template.body.suggestions" :key="n" :value="suggestion" is-preview />
        </div>
      </div>
    </template>
  </PhonePreview>
</template>
<!-- eslint-disable -->
<script>
import RcsBubble from '@/components/rcs/RcsBubble.vue';
import PhonePreview from '@/components/PhonePreview.vue';
import RcsCard from '@/components/rcs/RcsCard.vue';
import RcsMedia from '@/components/rcs/RcsMedia.vue';
import RcsSuggestion from '@/components/rcs/RcsSuggestion.vue';

export default {
  name: 'TemplatePreview',
  components: {
    RcsBubble,
    RcsCard,
    RcsMedia,
    RcsSuggestion,
    PhonePreview,
  },
  props: ['template'],
  watch: {
    template(newValue) {
      this.template = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.carousel {
  flex-wrap: nowrap;
  overflow: auto;
}
</style>
